import Component from '../../../../../../pages/vpp/features/buybox/generic-banner-price/index';

export default Component;
